import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Modal de confirmación para actualizar la evaluación
 */
const ConfirmacionActualizarModal = ({
  show,
  onConfirm,
  onCancel,
  isLoading
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '450px',
        width: '100%',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.06)',
        animation: 'slideIn 0.3s ease-out'
      }}>
        <style>{`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}</style>
        <div className="modal-header" style={{ marginBottom: '20px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            fontSize: '18px',
            fontWeight: '600',
            color: '#0063a1'
          }}>
            <FontAwesomeIcon icon="check-circle" />
            Confirmar actualización
          </div>
        </div>

        <div className="modal-body" style={{ marginBottom: '25px', color: '#333', lineHeight: '1.6' }}>
          <p style={{ margin: 0, fontSize: '15px' }}>
            ¿Desea actualizar la evaluación con los cambios realizados?
          </p>
        </div>

        <div className="modal-footer" style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center'
        }}>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onCancel}
            disabled={isLoading}
            style={{ 
              minWidth: '110px',
              border: '1.5px solid #ccc',
              transition: 'all 0.2s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = '#999';
              e.target.style.backgroundColor = '#f8f8f8';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = '#ccc';
              e.target.style.backgroundColor = 'white';
            }}
          >
            <FontAwesomeIcon icon="times" style={{ marginRight: '8px' }} />
            No, volver
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={onConfirm}
            disabled={isLoading}
            style={{ minWidth: '130px' }}
          >
            {isLoading ? (
              <>
                <div className="spinner-border spinner-border-sm me-2" role="status" style={{
                  width: '14px',
                  height: '14px',
                  display: 'inline-block'
                }}>
                  <span className="visually-hidden"></span>
                </div>
                Guardando...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon="save" style={{ marginRight: '8px' }} />
                Sí, actualizar
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmacionActualizarModal;
